<template>
  <div>
    <!-- <task-detail @onSave="refreshStages" @onDelete="refreshStages" /> -->
    <task-detail />

    <b-row>
      <b-col md="7" offset-md="2">
        <h1 class="title text-center mb-4">{{ $t("roadmap.gdpr.text") }}</h1>
        <div class="alert alert-info m-4">
          <h6>
            {{ $t("roadmap.init-alert") }}
          </h6>
        </div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_PRODUCT_TUTORIAL" :title="$t('roadmap.stage.gdpr-product-tutorial')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_DEPARTMENT_QUESTIONS" :title="$t('roadmap.stage.gdpr-department-questions')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_INVENTORY_UPDATE" :title="$t('roadmap.stage.gdpr-inventory-update')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_POLICY" :title="$t('roadmap.stage.gdpr-policy')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_RISK" :title="$t('roadmap.stage.gdpr-risk')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <Stage roadmapDefinition="GDPR_PRODUCT_ROADMAP" definition="GDPR_REPORT_PREPARE" :title="$t('roadmap.stage.gdpr-report-prepare')" />
      </b-col>
    </b-row>

    <!---->
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import Stage from "./component/roadmap-stage";

export default {
  components: { Stage },
  mounted() {
    const stages = ["GDPR_PRODUCT_TUTORIAL", "GDPR_DEPARTMENT_QUESTIONS", "GDPR_INVENTORY_UPDATE", "GDPR_POLICY", "GDPR_RISK", "GDPR_REPORT_PREPARE"];

    EventBus.$on("task-board-update", (e) => {
      stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
    EventBus.$on("roadmap-stage-updated", (e) => {
      e.stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
  },
  methods: {
    // refreshStages(item) {
    //   setTimeout(() => {
    //     const stage = item?.relations?.roadmapStage;
    //     if (stage?.roadmapDefinition == "GDPR_PRODUCT_ROADMAP") {
    //       this.loadStage(stage?.definition);
    //       stage.gdpr.next.forEach((s) => this.loadStage(s));
    //     }
    //   }, 4000);
    // },
    async loadStage(stage) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`organizationRoadmap/loadStage`, { roadmap: "GDPR_PRODUCT_ROADMAP", stage });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./roadmap";
</style>
